import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PieChartTwoToneSvg from "@ant-design/icons-svg/es/asn/PieChartTwoTone";
import AntdIcon from "../components/AntdIcon";
var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PieChartTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PieChartTwoTone.displayName = 'PieChartTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PieChartTwoTone);